import { selfGuidedTourVerificationMethods } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';

/**
 * Fetches the verification methods for a given specId.
 * @param {string} specId - The specId to fetch verification methods for.
 * @returns {Observable} An observable that emits the verification methods or an error object.
 */
export default function getVerificationMethods(specId) {
  const url = `${selfGuidedTourVerificationMethods}?specId=${specId}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        return response.json();
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    catchError((error) => of({ error: true, message: error.message }))
  );
}
